export const baseURL = process.env.REACT_APP_API_URL;
